import script from "./WebNav.vue?vue&type=script&setup=true&lang=js"
export * from "./WebNav.vue?vue&type=script&setup=true&lang=js"

import "./WebNav.vue?vue&type=style&index=0&id=06664fdf&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-06664fdf"]])

export default __exports__